<template>
  <ui-dialog
    :title='dialogTitle'
    :isVisible.sync='isVisible'
    :isLoading='isLoading'
    customClass="dialog-activity-review"
    @close='close'
  >
    <activity-item
      :data="data"
      :item="item"
      :formModel="formModel"
      :autoSave="mixAutoSave"
      class="open-po"
    />
  </ui-dialog>
</template>

<script>
import { routeEditLogic } from '@/mixins/modals'
import { ServiceRepairExchangeOrderFollowUp } from '@/services/RepairExchangeOrderFollowUp'
import { ModelOpenWO } from '@/models/RepairExchangeOrder'
import { AutoSaveMixin } from '@/mixins/FormAutoSave'

export default {
  name: 'DialogActivityItem',
  mixins: [routeEditLogic, AutoSaveMixin],
  components: {
    'activity-item': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/ActivityItemOpenWO/Index'),
    'ui-dialog': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/Dialog')
  },
  data () {
    return {
      isLoading: true,
      isVisible: false,
      data: {},
      item: {}
    }
  },
  computed: {
    isAvailableToSave () {
      return true
    },
    apiAutoSave () {
      return `RepairExchangeOrderFollowUps/Patch/${this.data.id}`
    },
    dialogTitle () {
      return this.L10n('open-wo')
    },
    selectRequest () {
      return [
        'id',
        'baxpo', 'reminderDate', 'partID', 'partSN', 'orderPhaseID', 'phaseDate',
        'phasePersonInChargeEmployeeID', 'lastInfo', 'shipped', 'shippedDate', 'quoteReceived', 'quoteReceivedDate',
        'quoteApproved', 'quoteApprovedDate', 'unitShipped', 'unitShippedDate', 'standby', 'standbyDate',

        'rfq.id as rfqID',
        'rfq.rfqid as rfqid',
        'rfq.po',
        'rfq.customerCompanyID',
        'rfq.customerContactID',
        'rfq.rfqTypeID',
        'rfq.baxEmployeeID',
        'rfq.poDate',
        'rfq.requestedDate',
        'rfq.pOIsOpen as poIsOpen',
        'rfq.observation',

        'rfq2.id as rfq2ID',
        'rfq2.supplierCompanyID',
        'rfq2.supplierContactID',
        'rfq2.conditionID',
        'rfq2.currencyID',
        'rfq2.estimatedDeliveryDate',
        'rfq2.receivedDate', 'rfq2.price',
        'rfq.salesOrders.Select(s => new { s.id, s.shippingPorformaNumber, s.awb, s.poStillOpen, s.remarks }) as salesOrders'
      ].join(',')
    }
  },
  methods: {
    formModel () {
      return new ModelOpenWO()
    },
    loadData (id) {
      this.isLoading = true
      ServiceRepairExchangeOrderFollowUp
        .getDynamic(id, {
          select: this.selectRequest
        })
        .then(({ data }) => {
          this.data = data
          this.item = data
        })
        .catch((err) => {
          this.requestErrorHandler(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    close () {
      this.mixSetRoute()
      this.$emit('onClose')
    },
    mixHookState ({ value, state }) {
      this.isVisible = true
      this.loadData(value)
    },
    mixHookReset () {
      this.data = {}
      this.item = {}
    },
    getFormData () {
      return {
        id: this.data.id
      }
    }
  }
}
</script>

<style lang="stylus">
  .dialog-activity-review{
    width: 100%;
    max-width: 120rem;
    margin-top: 3rem !important;
  }
</style>
